/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Kiotviet_Invoice_Not_FoundInputs */

const vi_error_kiotviet_invoice_not_found = /** @type {(inputs: Error_Kiotviet_Invoice_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KiotViet không có hoá đơn mang mã này.`)
};

/**

* @param {Error_Kiotviet_Invoice_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_invoice_not_found = /** @type {((inputs?: Error_Kiotviet_Invoice_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Invoice_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_invoice_not_found(inputs)
});